import { createFileRoute, notFound } from "@tanstack/react-router";

// Dev-only crash route: throws so the ErrorBoundary smoke test has something
// to catch. In production builds it disappears behind a notFound() so the
// route cannot be reached from the deployed app.
function CrashPage(): never {
  if (import.meta.env.PROD) throw notFound();
  throw new Error("intentional crash for e2e");
}

export const Route = createFileRoute("/crash")({ component: CrashPage });
